<template>
  <div class="card report-options flex flex-column align-item-start">
    <p>
      Анализирует результаты тестирования выбранной группы: средние показатели по всем метрикам, распределения по уровням развития и ключевые сильные/слабые зоны.
    </p>
    <div class="report-options__body">
      <div>
        <div class="label">
          Группа
        </div>
        <a-select
            v-model:value="group"
            :placeholder="'Выберите группу'"
            style="width: 100%;"
            :not-found-content="'Нет данных'"
            show-arrow
        >
          <a-select-option v-for="item in groupOptions" :key="item.id" :value="item.id">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div
      v-if="group !== null"
      class="report-options__btn flex justify-content-center"
    >
      <a-button @click="requestForReport" class="primary-button">
        Сформировать отчет
      </a-button>
    </div>
  </div>
</template>

<script>
import { computed, onBeforeMount, ref} from "@vue/runtime-core";
import { useStore } from "vuex";
import { LeftOutlined } from "@ant-design/icons-vue";
import {useRoute, useRouter} from "vue-router";

export default {
  components: { LeftOutlined },
  name: "base-report-parametres",
  setup(props, context) {
    const store = useStore();
    const group = ref(null),
      groupOptions = ref([])
    const selectedGroup = computed(() => store.state.analytics.selectedGroup),
      groups = computed(() => store.state.group.groups);

    const router = useRouter();

    onBeforeMount(() => {
      store.dispatch("group/getGroups").then(() => {
        groupOptions.value.push({ id: 0, text: "Все сотрудники"});
        groupOptions.value = groupOptions.value.concat(groups.value.map((group) => {
          return { id: group.id, text: group.name };
        }));

        if (selectedGroup.value) {
          group.value = String(selectedGroup.value.id);
        }
      });
    });

    const requestForReport = () => {
      store.dispatch('group/clearAnalyticsGroupData');
      let currentGroup;

      if (group.value !== 0) {
        currentGroup = groups.value.find((el) => el.id === group.value);
      }

      store.dispatch('group/setAnalyticsGroupData', {
        group_1: {
          name: currentGroup?.name ?? 'Все сотрудники',
          count: currentGroup?.users_count ?? null,
        },
        group_2: null,
      });

      context.emit("reportRequest", {
        group_id: group.value,
        // members: baseMembers.value,
      });
    };

    return {
      group,
      groupOptions,
      selectedGroup,
      groups,
      requestForReport,
      router
    };
  },
};
</script>

<style>
  .header {
    position: fixed;
    top: 0;
    padding: 15px 10px 0 10px;
    display: flex;
    justify-content: center;
    row-gap: 10px;
    column-gap: 25px;
    font-size: 20px;
    font-weight: 600;
    z-index: 25;
    
    @media (max-width: 910px) {
      font-size: 18px;
    }

    @media (max-width: 865px) {
      padding-top: 0;
      position: relative;
      margin-bottom: 20px;
      column-gap: 10px;
    }
  }

  .icon-back {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 24px;
    width: 24px;
    height: 24px;
    background-color: #FFFFFF;
    border-radius: 8px;
    cursor: pointer;

    .icon-arrow {
      width: 14px;
      height: 14px;
    }

    &:hover {
      .icon-arrow {
        color: var(--main-green);
      }
    }
  }

  .card {
    p {
      padding-left: 0;
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    .report-options__btn,
    .primary-button {
      width: 100%;
    }
  }
</style>